window.addEventListener('load', function() {
    const swiper = new Swiper('.grid_slider', {
    slidesPerView: 3,
    spaceBetween: 0,
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      641: {
        slidesPerView: 2.3,
        loop: true,
        navigation: false,
      },
      1025: {
        slidesPerView: 3,
        loop: false,
        navigation: false,
      },
    },
  })
})